"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useOutsideClick = callback => {
  const ref = _react.default.useRef();
  _react.default.useEffect(() => {
    const handleClick = event => {
      if (ref.current && !ref.current.contains(event.target)) callback();
    };
    document.addEventListener('click', handleClick, true);
    return () => {
      document.removeEventListener('click', handleClick, true);
    };
  }, [ref]);
  return ref;
};
const Modal = _ref => {
  let {
    children,
    isOpen,
    onClose,
    width = '540px'
  } = _ref;
  const showRef = _react.default.useRef(isOpen);
  const ref = useOutsideClick(() => onClose());
  const overlayRef = _react.default.useRef(null);
  const downHandler = event => {
    if (event.key === 'Escape' && showRef.current) onClose();
  };
  _react.default.useEffect(() => {
    showRef.current = isOpen;
    let timeout = setTimeout(() => {
      if (isOpen) {
        ref.current.style.transform = "translate(-50%, 0px)";
        ref.current.style.opacity = "1";
        overlayRef.current.style.opacity = "1";
      }
    }, 0);
    return () => {
      clearTimeout(timeout);
    };
  }, [isOpen]);
  _react.default.useEffect(() => {
    document.addEventListener('keydown', downHandler);
    return () => {
      document.removeEventListener('keydown', downHandler);
    };
  }, []);
  if (!isOpen) return null;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    ref: overlayRef,
    className: "hpd-modal-overlay",
    style: {
      opacity: 0,
      transition: '200ms cubic-bezier(.215,.61,.355,1)'
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    ref: ref,
    className: "hpd-modal",
    style: {
      transform: "translate(-50%, -1em)",
      transition: '200ms cubic-bezier(.215,.61,.355,1)',
      opacity: 0,
      width,
      maxWidth: width
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "hpd-modal-content border br-6px"
  }, children)));
};
var _default = exports.default = Modal;